import { useNavigate } from "react-router-dom";

const categories = [
  {
    icon: "ri-landscape-line",
    title: "Doğa & Yayla",
    desc: "Karadeniz yaylaları, vadiler ve el değmemiş doğa",
    count: "34 yer",
    color: "bg-emerald-50",
    iconColor: "text-emerald-600",
    path: "/places?cat=doga",
    image: "https://readdy.ai/api/search-image?query=Turkey%20nature%20plateau%20green%20mountains%20waterfall%20lush%20landscape%20Karadeniz&width=400&height=280&seq=cat1&orientation=landscape",
  },
  {
    icon: "ri-ancient-gate-line",
    title: "Tarihi Yerler",
    desc: "Antik kentler, manastırlar ve Osmanlı mirası",
    count: "28 yer",
    color: "bg-amber-50",
    iconColor: "text-amber-600",
    path: "/places?cat=tarih",
    image: "https://readdy.ai/api/search-image?query=Turkey%20historical%20ruins%20ancient%20city%20Ottoman%20architecture%20Cappadocia%20stone%20buildings%20heritage&width=400&height=280&seq=cat2&orientation=landscape",
  },
  {
    icon: "ri-restaurant-line",
    title: "Gastronomi",
    desc: "Yerel lezzetler, tarihi lokantalar ve sokak yemekleri",
    count: "42 restoran",
    color: "bg-rose-50",
    iconColor: "text-rose-600",
    path: "/restoranlar",
    image: "https://readdy.ai/api/search-image?query=Turkish%20food%20gastronomy%20baklava%20kebab%20meze%20colorful%20dishes%20traditional%20cuisine%20spread&width=400&height=280&seq=cat3&orientation=landscape",
  },
  {
    icon: "ri-sailboat-line",
    title: "Ada & Deniz",
    desc: "Ege adaları, Akdeniz koyları ve mavi yolculuklar",
    count: "19 yer",
    color: "bg-sky-50",
    iconColor: "text-sky-600",
    path: "/places?cat=ada",
    image: "https://readdy.ai/api/search-image?query=Turkey%20Aegean%20island%20sea%20turquoise%20water%20boat%20sailing%20Bozcaada%20coast%20summer&width=400&height=280&seq=cat4&orientation=landscape",
  },
  {
    icon: "ri-building-2-line",
    title: "Şehir Rehberi",
    desc: "İstanbul'dan Mardin'e şehirlerin gizli köşeleri",
    count: "31 rehber",
    color: "bg-violet-50",
    iconColor: "text-violet-600",
    path: "/articles?cat=sehir",
    image: "https://readdy.ai/api/search-image?query=Turkey%20city%20guide%20Istanbul%20Mardin%20Gaziantep%20urban%20streets%20local%20neighborhood%20authentic%20atmosphere&width=400&height=280&seq=cat5&orientation=landscape",
  },
  {
    icon: "ri-star-smile-line",
    title: "Underrated",
    desc: "Turistlerin henüz keşfetmediği gizli cennetler",
    count: "22 yer",
    color: "bg-orange-50",
    iconColor: "text-orange-600",
    path: "/places?cat=underrated",
    image: "https://readdy.ai/api/search-image?query=Turkey%20hidden%20gems%20underrated%20secret%20places%20off%20beaten%20path%20authentic%20local%20discovery&width=400&height=280&seq=cat6&orientation=landscape",
  },
];

const CategoriesSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="text-amber-500 text-sm font-semibold uppercase tracking-widest">Kategoriler</span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mt-2" style={{ fontFamily: "'Playfair Display', serif" }}>
            Ne Arıyorsunuz?
          </h2>
          <p className="text-stone-500 mt-3 max-w-xl mx-auto text-sm">
            Doğadan tarihe, gastronomi turlarından ada kaçamakları — her zevke uygun içerik.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <button
              key={cat.title}
              onClick={() => navigate(cat.path)}
              className="group text-left bg-white rounded-2xl overflow-hidden hover:scale-[1.02] transition-transform duration-200 cursor-pointer"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className={`absolute top-3 left-3 w-9 h-9 flex items-center justify-center rounded-xl ${cat.color}`}>
                  <i className={`${cat.icon} ${cat.iconColor} text-base`}></i>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="font-semibold text-stone-900 text-sm">{cat.title}</h3>
                  <span className="text-xs text-stone-400">{cat.count}</span>
                </div>
                <p className="text-xs text-stone-500 leading-relaxed">{cat.desc}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;
